export default __webpack_public_path__ + "static/media/yeti_poster.4f203583.jpg";